import React from 'react';

import { Stack } from '@atlaskit/primitives';

import { withErrorBoundary, Attribution } from '@confluence/error-boundary';
import { useContentType } from '@confluence/page-context';
import { ScreenEvent } from '@confluence/analytics';
import {
	SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE,
	ExperienceSuccess,
} from '@confluence/experience-tracker';

import { PeopleSection } from './components/PeopleSection';
import { StatsSection } from './components/StatsSection';
import { InfoSection } from './components/InfoSection';
import { ConnectionsSection } from './components/ConnectionsSection';
import { useElementVisibility, ELEMENTS } from './hooks/useIsElementVisible';

const DetailsPanelComponent = () => {
	const { isElementVisible } = useElementVisibility();
	const [contentType] = useContentType();

	return (
		<>
			<Stack testId="details-panel-body">
				<PeopleSection />
				<StatsSection />
				{isElementVisible(ELEMENTS.SECTIONS.PROPERTIES) && <InfoSection />}
				{isElementVisible(ELEMENTS.SECTIONS.CONNECTIONS) && <ConnectionsSection />}
			</Stack>
			<ExperienceSuccess name={SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE} />
			<ScreenEvent name="detailsPanelScreen" id="detailsPanelScreen" attributes={{ contentType }} />
		</>
	);
};

export const DetailsPanelBody = withErrorBoundary({
	attribution: Attribution.COMMENTS,
})(DetailsPanelComponent);
